"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagAndInput = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../atoms/ScreenHeader/index");

var _index2 = require("../../atoms/GeneralInput/index");

var _react = require("react");

var _acceptIcon = _interopRequireDefault(require("../../../assets/images/generalButton/acceptIcon.svg"));

var _rejectIcon = _interopRequireDefault(require("../../../assets/images/generalButton/rejectIcon.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var TagAndInput = function TagAndInput(_ref) {
  var inputType = _ref.inputType,
      label = _ref.label,
      value = _ref.value,
      inputPlaceHolder = _ref.inputPlaceHolder,
      inputId = _ref.inputId,
      updatedDescriptions = _ref.updatedDescriptions,
      setUpdatedDescriptions = _ref.setUpdatedDescriptions,
      updatedDatasheets = _ref.updatedDatasheets,
      setUpdatedDatasheets = _ref.setUpdatedDatasheets,
      articleId = _ref.articleId,
      version = _ref.version,
      index = _ref.index,
      isRequired = _ref.isRequired,
      dinamicHeight = _ref.dinamicHeight,
      inputCols = _ref.inputCols,
      inputRows = _ref.inputRows,
      maxChar = _ref.maxChar,
      required = _ref.required,
      optionList = _ref.optionList,
      description = _ref.description,
      inputOnChange = _ref.inputOnChange,
      color = _ref.color,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      showTooltip = _ref.showTooltip,
      auditClass = _ref.auditClass,
      onChange = _ref.onChange,
      dataInputs = _ref.dataInputs,
      inputGroup = _ref.inputGroup,
      boxOnboardingData = _ref.boxOnboardingData;

  var _useState = (0, _react.useState)(boxOnboardingData || []),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      boxOnboardingList = _useState2[0],
      setBoxOnboardingList = _useState2[1];

  (0, _react.useEffect)(function () {
    var temp = {};
    var maxBoxId = 0;
    inputGroup === null || inputGroup === void 0 ? void 0 : inputGroup.inputs.forEach(function (attrId) {
      if (!dataInputs[attrId].box) return;
      Object.entries(dataInputs[attrId].box).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            boxId = _ref3[0],
            value = _ref3[1];

        if (boxId > maxBoxId) maxBoxId = boxId;
        if (!temp[boxId]) temp[boxId] = {};
        temp[boxId][attrId] = value;
      });
    });
    var tempList = Object.values(temp);

    if (tempList.length > 0) {
      setBoxOnboardingList(tempList.map(function (value, index) {
        return index === tempList.length - 1 ? {
          value: value
        } : {
          value: value
        };
      }));
    }
  }, []);
  (0, _react.useEffect)(function () {
    onChange && onChange(boxOnboardingList);
  }, [boxOnboardingList]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    inputType: inputType,
    className: "input-container",
    children: [(label === null || label === void 0 ? void 0 : label.length) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "title-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ScreenHeader, {
        text: label,
        headerType: "input-name-header",
        color: color
      }), showTooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "tooltip",
        children: label
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.GeneralInput, {
      inputId: inputId,
      inputType: inputType,
      inputValue: value,
      index: index,
      disabled: disabled,
      isRequired: isRequired,
      inputPlaceholder: inputPlaceHolder,
      updatedDescriptions: updatedDescriptions,
      setUpdatedDescriptions: setUpdatedDescriptions,
      updatedDatasheets: updatedDatasheets,
      setUpdatedDatasheets: setUpdatedDatasheets,
      articleId: articleId,
      version: version,
      dinamicHeight: dinamicHeight,
      inputCols: inputCols,
      inputRows: inputRows,
      maxChar: maxChar,
      required: required,
      optionList: optionList,
      description: description,
      inputOnChange: inputOnChange,
      onKeyDown: onKeyDown,
      auditClass: auditClass,
      onChange: function onChange(e) {
        setBoxOnboardingList(function (prev) {
          return prev.map(function (box, i) {
            if (i != index) {
              return box;
            }

            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, box), {}, {
              value: e
            });
          });
        });
      }
    })]
  }, "generalTagInput-".concat(inputType));
};

exports.TagAndInput = TagAndInput;